import { ArrowLeft, FileText, Shield, AlertTriangle, Scale } from "lucide-react";

export default function TermsOfLicensePage() {
  return (
    <div className="min-h-screen bg-[#0F1115]" data-testid="terms-of-license-page">
      {/* Header */}
      <header className="border-b border-[#2A2F38]">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2 text-[#9CA3AF] hover:text-[#E5E7EB] transition-colors">
            <ArrowLeft className="h-4 w-4" />
            <span className="text-sm">Voltar</span>
          </a>
          <h1 className="font-heading text-xl font-bold">
            <span className="text-[#F59E0B]">Kp</span>
            <span className="text-[#E5E7EB]">Action</span>
          </h1>
        </div>
      </header>

      {/* Main Content */}
      <main className="py-16 px-6">
        <div className="max-w-3xl mx-auto">
          {/* Title */}
          <div className="text-center mb-12">
            <div className="w-16 h-16 bg-[#0E3A46] rounded-sm flex items-center justify-center mx-auto mb-6">
              <FileText className="h-8 w-8 text-[#F59E0B]" />
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-[#E5E7EB] mb-4">
              Termos de Licença
            </h1>
            <p className="text-[#9CA3AF]">
              Contrato de Licença de Uso do Software KpAction
            </p>
            <p className="text-xs text-[#6B7280] mt-2">
              Última atualização: Março 2026
            </p>
          </div>

          {/* Content */}
          <div className="space-y-8">
            {/* Section 1 */}
            <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <Scale className="h-5 w-5 text-[#F59E0B]" />
                <h2 className="font-heading text-xl font-bold text-[#E5E7EB]">
                  1. Definições
                </h2>
              </div>
              <div className="space-y-4 text-[#9CA3AF] text-sm leading-relaxed">
                <p>
                  <strong className="text-[#E5E7EB]">1.1. "Software"</strong> refere-se ao programa de computador KpAction, 
                  incluindo todas as suas funcionalidades, módulos, atualizações e documentação associada.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">1.2. "Licenciante"</strong> refere-se à EVIDENTIA TECNOLOGIA LTDA, 
                  CNPJ 65.097.807/0001-30, titular dos direitos sobre o Software.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">1.3. "Licenciado"</strong> refere-se à pessoa jurídica ou física que 
                  adquire o direito de uso do Software mediante pagamento da licença.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">1.4. "Chave de Ativação"</strong> refere-se ao código único fornecido 
                  para ativação do Software, vinculado ao CNPJ e dispositivo do Licenciado.
                </p>
              </div>
            </section>

            {/* Section 2 */}
            <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <Shield className="h-5 w-5 text-[#F59E0B]" />
                <h2 className="font-heading text-xl font-bold text-[#E5E7EB]">
                  2. Concessão de Licença
                </h2>
              </div>
              <div className="space-y-4 text-[#9CA3AF] text-sm leading-relaxed">
                <p>
                  <strong className="text-[#E5E7EB]">2.1.</strong> O Licenciante concede ao Licenciado uma licença 
                  <strong className="text-[#F59E0B]"> não exclusiva, intransferível e limitada</strong> para uso do Software.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">2.2.</strong> A licença é válida pelo período de 
                  <strong className="text-[#F59E0B]"> 12 (doze) meses</strong> contados a partir da data de envio da Chave de Ativação ao Licenciado, realizada pelo Licenciante após a confirmação do pagamento.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">2.3.</strong> A licença é vinculada:
                </p>
                <ul className="list-disc list-inside pl-4 space-y-1">
                  <li>Ao CNPJ da empresa cadastrada no momento da compra</li>
                  <li>Ao dispositivo (computador) onde a ativação for realizada</li>
                  <li>À Chave de Ativação única fornecida</li>
                </ul>
                <p>
                  <strong className="text-[#E5E7EB]">2.4.</strong> A licença inclui:
                </p>
                <ul className="list-disc list-inside pl-4 space-y-1">
                  <li>Acesso a todas as funcionalidades do Software</li>
                  <li>Atualizações disponibilizadas durante o período contratado</li>
                  <li>Suporte técnico básico via e-mail</li>
                </ul>
                <div className="mt-6 pt-4 border-t border-[#2A2F38]">
                  <p className="mb-3">
                    <strong className="text-[#E5E7EB]">2.5. Renovação de Licença</strong>
                  </p>
                  <p className="mb-2">
                    A licença concedida possui prazo determinado de 12 (doze) meses, não sendo renovada automaticamente.
                  </p>
                  <p className="mb-2">
                    Eventual renovação do direito de uso dependerá da aquisição de nova licença após o término do período contratado.
                  </p>
                  <p>
                    A renovação estará sujeita às condições comerciais vigentes no momento da nova aquisição, podendo incluir alterações de preço, modelo de licenciamento ou funcionalidades disponíveis.
                  </p>
                </div>
              </div>
            </section>

            {/* Section 3 */}
            <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <AlertTriangle className="h-5 w-5 text-[#EF4444]" />
                <h2 className="font-heading text-xl font-bold text-[#E5E7EB]">
                  3. Restrições de Uso
                </h2>
              </div>
              <div className="space-y-4 text-[#9CA3AF] text-sm leading-relaxed">
                <p>
                  <strong className="text-[#E5E7EB]">3.1.</strong> O Licenciado <strong className="text-[#EF4444]">NÃO PODE</strong>:
                </p>
                <ul className="list-disc list-inside pl-4 space-y-2">
                  <li>Copiar, modificar, adaptar ou criar obras derivadas do Software</li>
                  <li>Realizar engenharia reversa, descompilar ou desmontar o Software</li>
                  <li>Sublicenciar, alugar, emprestar ou transferir a licença a terceiros</li>
                  <li>Utilizar o Software em mais de um dispositivo simultaneamente</li>
                  <li>Remover ou alterar avisos de propriedade intelectual</li>
                  <li>Utilizar o Software para fins ilegais ou não autorizados</li>
                  <li>Compartilhar a Chave de Ativação com terceiros</li>
                </ul>
                <p>
                  <strong className="text-[#E5E7EB]">3.2.</strong> A violação de qualquer restrição acima resultará em 
                  <strong className="text-[#EF4444]"> cancelamento imediato da licença</strong>, sem direito a reembolso.
                </p>
              </div>
            </section>

            {/* Section 4 */}
            <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-6 md:p-8">
              <h2 className="font-heading text-xl font-bold text-[#E5E7EB] mb-4">
                4. Propriedade Intelectual
              </h2>
              <div className="space-y-4 text-[#9CA3AF] text-sm leading-relaxed">
                <p>
                  <strong className="text-[#E5E7EB]">4.1.</strong> O Software é protegido por leis de direitos autorais 
                  e tratados internacionais. O Licenciante retém todos os direitos, títulos e interesses sobre o Software.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">4.2.</strong> Esta licença não transfere ao Licenciado qualquer 
                  direito de propriedade sobre o Software, apenas o direito de uso conforme os termos aqui estabelecidos.
                </p>
              </div>
            </section>

            {/* Section 5 */}
            <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-6 md:p-8">
              <h2 className="font-heading text-xl font-bold text-[#E5E7EB] mb-4">
                5. Privacidade e Dados
              </h2>
              <div className="space-y-4 text-[#9CA3AF] text-sm leading-relaxed">
                <p>
                  <strong className="text-[#E5E7EB]">5.1.</strong> O Software opera <strong className="text-[#10B981]">localmente</strong> 
                  {" "}e não transmite dados operacionais para servidores externos.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">5.2.</strong> Os dados inseridos pelo Licenciado permanecem 
                  exclusivamente no dispositivo onde o Software está instalado.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">5.3.</strong> O Licenciante coleta apenas dados necessários para:
                </p>
                <ul className="list-disc list-inside pl-4 space-y-1">
                  <li>Validação da licença</li>
                  <li>Emissão de nota fiscal</li>
                  <li>Comunicação sobre atualizações e suporte</li>
                </ul>
                <p>
                  <strong className="text-[#E5E7EB]">5.4.</strong> O tratamento de dados está em conformidade com a 
                  Lei Geral de Proteção de Dados (LGPD).
                </p>
              </div>
            </section>

            {/* Section 6 */}
            <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-6 md:p-8">
              <h2 className="font-heading text-xl font-bold text-[#E5E7EB] mb-4">
                6. Limitação de Responsabilidade
              </h2>
              <div className="space-y-4 text-[#9CA3AF] text-sm leading-relaxed">
                <p>
                  <strong className="text-[#E5E7EB]">6.1.</strong> O Software é fornecido "como está". O Licenciante não 
                  garante que o Software atenderá a todos os requisitos específicos do Licenciado.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">6.2.</strong> O Licenciante não será responsável por danos indiretos, 
                  incidentais, especiais ou consequenciais decorrentes do uso do Software.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">6.3.</strong> A responsabilidade total do Licenciante está limitada 
                  ao valor pago pela licença.
                </p>
              </div>
            </section>

            {/* Section 7 - Limitação de Responsabilidade Analítica */}
            <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <AlertTriangle className="h-5 w-5 text-[#F59E0B]" />
                <h2 className="font-heading text-xl font-bold text-[#E5E7EB]">
                  7. Limitação de Responsabilidade Analítica
                </h2>
              </div>
              <div className="space-y-4 text-[#9CA3AF] text-sm leading-relaxed">
                <p>
                  <strong className="text-[#E5E7EB]">7.1.</strong> O KpAction fornece análises automatizadas baseadas em 
                  modelos matemáticos aplicados aos dados inseridos pelo usuário.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">7.2.</strong> As interpretações apresentadas possuem{" "}
                  <strong className="text-[#F59E0B]">caráter analítico e indicativo</strong>, não constituindo garantia 
                  de resultado operacional, financeiro ou estratégico.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">7.3.</strong> As decisões operacionais tomadas com base nas análises 
                  fornecidas pelo software são de <strong className="text-[#F59E0B]">responsabilidade exclusiva do usuário</strong>.
                </p>
              </div>
            </section>

            {/* Section 8 - Não Substituição de Consultoria */}
            <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-6 md:p-8">
              <h2 className="font-heading text-xl font-bold text-[#E5E7EB] mb-4">
                8. Cláusula de Não Substituição de Consultoria
              </h2>
              <div className="space-y-4 text-[#9CA3AF] text-sm leading-relaxed">
                <p>
                  <strong className="text-[#E5E7EB]">8.1.</strong> O software{" "}
                  <strong className="text-[#EF4444]">NÃO substitui</strong> consultoria empresarial, planejamento 
                  estratégico profissional ou análise financeira especializada.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">8.2.</strong> O KpAction deve ser utilizado como{" "}
                  <strong className="text-[#F59E0B]">ferramenta de apoio analítico</strong> à interpretação operacional.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">8.3.</strong> O software não fornece recomendações de ação específicas, 
                  aconselhamento empresarial ou orientação estratégica personalizada.
                </p>
              </div>
            </section>

            {/* Section 9 - Proteção Tecnológica */}
            <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <Shield className="h-5 w-5 text-[#F59E0B]" />
                <h2 className="font-heading text-xl font-bold text-[#E5E7EB]">
                  9. Proteção Tecnológica
                </h2>
              </div>
              <div className="space-y-4 text-[#9CA3AF] text-sm leading-relaxed">
                <p>
                  <strong className="text-[#E5E7EB]">9.1.</strong> É <strong className="text-[#EF4444]">proibida</strong> a 
                  engenharia reversa, descompilação, modificação, redistribuição ou tentativa de extração do código do 
                  software sem autorização formal da EVIDENTIA TECNOLOGIA LTDA.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">9.2.</strong> Qualquer tentativa de violação da estrutura tecnológica 
                  implicará <strong className="text-[#EF4444]">cancelamento imediato da licença</strong>, sem direito a reembolso.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">9.3.</strong> O Licenciante reserva-se o direito de tomar medidas legais 
                  cabíveis contra violações de propriedade intelectual.
                </p>
              </div>
            </section>

            {/* Section 10 - Garantia Limitada */}
            <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-6 md:p-8">
              <h2 className="font-heading text-xl font-bold text-[#E5E7EB] mb-4">
                10. Garantia Limitada
              </h2>
              <div className="space-y-4 text-[#9CA3AF] text-sm leading-relaxed">
                <p>
                  <strong className="text-[#E5E7EB]">10.1.</strong> O software é fornecido no estado em que se encontra 
                  (<strong className="text-[#F59E0B]">"as is"</strong>), sem garantia de adequação a finalidade específica 
                  ou garantia de desempenho operacional específico.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">10.2.</strong> O Licenciante não garante que o Software funcionará de 
                  forma ininterrupta ou livre de erros.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">10.3.</strong> Eventuais correções ou atualizações serão disponibilizadas 
                  a critério exclusivo do Licenciante durante o período de vigência da licença.
                </p>
              </div>
            </section>

            {/* Section 11 */}
            <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-6 md:p-8">
              <h2 className="font-heading text-xl font-bold text-[#E5E7EB] mb-4">
                11. Disposições Gerais
              </h2>
              <div className="space-y-4 text-[#9CA3AF] text-sm leading-relaxed">
                <p>
                  <strong className="text-[#E5E7EB]">11.1.</strong> Este contrato é regido pelas leis da República 
                  Federativa do Brasil.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">11.2.</strong> Fica eleito o foro da Comarca de São Paulo/SP para 
                  dirimir quaisquer controvérsias.
                </p>
                <p>
                  <strong className="text-[#E5E7EB]">11.3.</strong> A aceitação destes termos ocorre no momento da 
                  compra da licença, início do período de teste ou utilização do software após o recebimento da Chave de Ativação.
                </p>
              </div>
            </section>

            {/* Company Info */}
            <div className="text-center pt-8 border-t border-[#2A2F38]">
              <p className="text-sm text-[#E5E7EB] font-medium">EVIDENTIA TECNOLOGIA LTDA</p>
              <p className="text-xs text-[#6B7280] mt-1">CNPJ: 65.097.807/0001-30</p>
              <p className="text-xs text-[#6B7280] mt-1">
                Av. Raimundo Pereira de Magalhães, 1652 - Apt 42 Bloco II
              </p>
              <p className="text-xs text-[#6B7280]">Jardim Iris — São Paulo/SP</p>
              <p className="text-xs text-[#6B7280] mt-2">contato@kpaction.com.br</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
